import React from 'react';

export default function Marquee() {
  const items = ['STRENGTH', 'POWER', 'COMMUNITY', 'DISCIPLINE', 'GROWTH', 'GRIT', 'FOCUS', 'RESULTS'];
  return (
    <section className="relative py-8 bg-black border-y border-red-600/20 overflow-hidden">
      <div className="flex marquee-track whitespace-nowrap">
        {[...items, ...items, ...items].map((it, i) => (
          <div key={`${it}-${i}`} className="flex items-center gap-12 px-12">
            <span className="font-display text-5xl md:text-7xl tracking-wider text-white/5 hover:text-red-500/80 transition-colors">{it}</span>
            <span className="w-3 h-3 rounded-full bg-red-600/60" />
          </div>
        ))}
      </div>
    </section>
  );
}
